/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/VerifySection.css";
import aiIcon from "../assets/icon-ai.png";
import arrowIcon from "../assets/arrow.png";
import timeIcon from "../assets/icon-time.png";

const VerifySection = () => {
  const navigate = useNavigate();

  return (
    <section className="verify-section">
      <div className="verify-inner">
        <h2 className="section-title">VERIFY</h2>
        <div className="verify-card-group">
          {/* Card 1 */}
          <div className="verify-card" onClick={() => navigate("/ask")}>
            <img src={aiIcon} alt="AI" className="card-icon" />
            <h3 className="card-title">
              Use AI to fact-check political claims
            </h3>
            <p className="card-body">
              Instant verification of political statements using advanced AI
            </p>
            <a className="card-link">
              Start Fact-Checking <img src={arrowIcon} alt="arrow" />
            </a>
          </div>

          {/* Card 2 */}
          <div
            className="verify-card"
            onClick={() => navigate("/policy-tracker")}
          >
            <img src={timeIcon} alt="AI" className="card-icon" />
            <h3 className="card-title">Track policy implementation</h3>
            <p className="card-body">
              Monitor and verify the progress of policy promises using AI
              analysis
            </p>
            <a className="card-link">
              Track Policies <img src={arrowIcon} alt="arrow" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifySection;
